import React, { useState } from 'react';
import useAnalyticEvents from '@hooks/analytics/use-analytic-events';
import Dialog from '@components/atoms/dialog/dialog';
import SellerFees from '../seller-fees';

type SellerFeesModalProps = {
  children: React.ReactNode;
  feeDetails?: {
    sellerFee?: string;
    paymentProcessing?: string;
  };
};

const SellerFeesModal: React.FC<SellerFeesModalProps> = ({ children, feeDetails }): React.JSX.Element => {
  const { sendAnalyticEvent } = useAnalyticEvents('product');
  const [openModal, setOpenModal] = useState(false);

  const onOpenModal = () => {
    sendAnalyticEvent('monetization_show_seller_fee');
    setOpenModal(true);
  };

  const onCloseModal = () => {
    sendAnalyticEvent('monetization_seller_fee_pop_in_close', {
      label: feeDetails?.sellerFee,
    });
    setOpenModal(false);
  };

  return (
    <>
      <button
        type="button"
        onClick={onOpenModal}
      >
        {children}
      </button>
      <Dialog
        key="sellerFeesModal"
        isOpen={openModal}
        hasCloseIcon
        closeDialog={onCloseModal}
        styles={{
          content: {
            maxWidth: '660px',
            width: '100%',
          },
        }}
      >
        {(modalDialogTitleId) => (
          <SellerFees
            feeDetails={feeDetails}
            modalDialogTitleId={modalDialogTitleId}
          />
        )}
      </Dialog>
    </>
  );
};

export default SellerFeesModal;
